import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

const HEADERS = ['Transaction Method', 'Payment Status', 'Start Date', 'End Date'];

function rowsFromPayments(payments) {
  return payments.map((p) => [
    p.transactionType ?? '',
    p.paymentStatus ?? '',
    p.startDate ?? '',
    p.endDate ?? '',
  ]);
}

function escapeCsvCell(value) {
  const s = String(value ?? '');
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/** @param {Array<{transactionType?: string, paymentStatus?: string, startDate?: string, endDate?: string}>} payments */
export function downloadPaymentsCsv(payments, filename = 'payments.csv') {
  const lines = [
    HEADERS.map(escapeCsvCell).join(','),
    ...rowsFromPayments(payments).map((row) => row.map(escapeCsvCell).join(',')),
  ];
  const blob = new Blob(['\ufeff', lines.join('\r\n')], {
    type: 'text/csv;charset=utf-8;',
  });
  triggerDownload(blob, filename);
}

/** @param {Array<{transactionType?: string, paymentStatus?: string, startDate?: string, endDate?: string}>} payments */
export function downloadPaymentsExcel(payments, filename = 'payments.xlsx') {
  const sheetData = [HEADERS, ...rowsFromPayments(payments)];
  const ws = XLSX.utils.aoa_to_sheet(sheetData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Payments');
  XLSX.writeFile(wb, filename);
}

/** @param {Array<{transactionType?: string, paymentStatus?: string, startDate?: string, endDate?: string}>} payments */
export function downloadPaymentsPdf(payments, filename = 'payments.pdf') {
  const doc = new jsPDF({ orientation: 'landscape' });
  doc.setFontSize(14);
  doc.text('Payments', 14, 16);
  autoTable(doc, {
    startY: 22,
    head: [HEADERS],
    body: rowsFromPayments(payments),
    styles: { fontSize: 9 },
    headStyles: { fillColor: [66, 66, 66] },
  });
  doc.save(filename);
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
